export default __webpack_public_path__ + "static/media/Shaded Strike.6b7a1981.png";